import _ from 'lodash'
import api from '../../api'

const defaultState = () => ({
  teamFinance: [],
  teamRanking: [],
  financialOverview: [],
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    teamFinancialOverview: state => state.teamFinance,
    teamRanking: state => state.teamRanking,
    financialOverview: state => state.financialOverview,
  },
  actions: {
    async fetchMyTeamFinance({ commit, getters }) {
      const team = getters.myTeam
      if (team) {
        try {
          const { data } = await api.gameData.findAllTeamTurnHistoryByTeamId(team.id)
          commit('SET_MY_FINANCE', data)
        } catch (e) {
          //this.$toast.error('Something went wrong!');
        }
      }
    },

    async fetchTeamRanking({ commit, getters }) {
      const gameId = getters.activeGame.id
      try {
        const { data } = await api.gameData.findTeamRankingByGameId(gameId)
        commit('SET_TEAM_RANKING', data)
      } catch (e) {
        //this.$toast.error('Something went wrong!');
      }
    },
    async fetchFinancialOverview({ commit, getters }) {
      const gameId = getters.activeGame.id
      try {
        const { data } = await api.gameData.financeOverview(gameId)
        const grouped = _.groupBy(data, item => item.teamId)
        const teamRanking = []
        _.forOwn(grouped, teamRows => {
          if (teamRows[0]) {
            teamRanking.push({
              id: teamRows[0].teamId,
              name: getters.gameAllTeams.find(team => team.id === teamRows[0].teamId).name,
              results: teamRows,
            })
          }
        })
        commit('SET_FINANCIAL_OVERVIEW', teamRanking)
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
    },
  },
  mutations: {
    SET_MY_FINANCE(state, data) {
      state.teamFinance = data || []
    },
    SET_TEAM_RANKING(state, data) {
      state.teamRanking = data || []
    },
    SET_FINANCIAL_OVERVIEW(state, data) {
      state.financialOverview = data || []
    },
  }
}
